export default __webpack_public_path__ + "login-background.6f8609fd6c278018c39425ebfc8935f4.svg";